module.exports = __webpack_public_path__ + "media/images/favicon-4e84b2405a9fa3c6b794b712d4f3a58c.png";